import { useMemo } from 'react'
import { studentsStore } from 'pages/Students/model/studentsStore'
import { getCountryNameByIso2 } from 'shared/utils/countryNameByIso2'

export const useCountryExplorationSubmission = ({ assignment, student }) => {
	const studentId = student?.id

	const studentData = useMemo(() => {
		if (!studentId) return null
		return studentsStore.getStudentById(studentId)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [studentId, studentsStore.students])

	const rawCountries = useMemo(() => {
		if (!studentData) return []
		
		if (studentData.target_countries && Array.isArray(studentData.target_countries) && studentData.target_countries.length > 0) {
			return studentData.target_countries
		}
		
		if (studentData.dream_country) {
			return [studentData.dream_country]
		}
		
		return []
	}, [studentData])

	const isLoading = false
	const error = null

	let countriesArray = []
	if (rawCountries) {
		if (Array.isArray(rawCountries)) {
			countriesArray = rawCountries
		} else if (typeof rawCountries === 'string') {
			countriesArray = [rawCountries]
		} else {
			countriesArray = [rawCountries]
		}
	}

	const countries = countriesArray.map(country => {
		if (typeof country === 'string') {
			return { name: country }
		}

		if (country?.name) {
			return { name: country.name, ...country }
		}

		if (country?.countryName) {
			return { name: country.countryName, ...country }
		}

		if (country?.iso2 || country?.countryCode || country?.code) {
			const iso2 = country.iso2 || country.countryCode || country.code
			const countryName = getCountryNameByIso2(iso2)
			return { name: countryName || iso2, ...country }
		}

		if (country?.title) {
			return { name: country.title, ...country }
		}

		return { name: 'Unknown Country', ...country }
	}) || []
	const responseText =
		student?.response_text ||
		student?.responseText ||
		student?.assignmentData?.response_text ||
		assignment?.students?.find(s => s.id === student?.id)?.response_text ||
		''

	return {
		countries,
		isLoading,
		error,
		responseText,
		hasResponse: Boolean(responseText && responseText.trim()),
	}
}

export default useCountryExplorationSubmission
